import Swiper from 'swiper';
import {Navigation, Pagination, Mousewheel, Autoplay} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const sectionSliders = document.querySelectorAll('.section-slider .swiper');
    sectionSliders.forEach(function (slider) {
        new Swiper(slider, {
            modules: [Navigation, Pagination, Mousewheel, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            simulateTouch: true,
            allowTouchMove: true,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            }
        });
    });
});
